module.exports = __webpack_public_path__ + "img/writeComment.c77569ae.svg";